module.exports = __webpack_public_path__ + "res/img_game_bg_t.841cd4ec3056d57e7a7506d3fc5c9169.png";